import { useGalleryPortalId } from '@onefootprint/ui';
import { NAVIGATION_HEADER_PORTAL_ID } from '@/idv2/components/constants';

// The id the NavigationHeader should portal into. Inside a Storybook gallery a
// GalleryCard scopes it per card (so each page's header lands in its own in-card
// node instead of several cards colliding on one shared target); everywhere else
// it's the single global target, so the real app is unaffected.
export const useNavigationHeaderPortalId = () => {
  return useGalleryPortalId() ?? NAVIGATION_HEADER_PORTAL_ID;
};